import { render } from "./coursedetail.vue?vue&type=template&id=d42e94e0&scoped=true&ts=true"
import script from "./coursedetail.vue?vue&type=script&lang=ts"
export * from "./coursedetail.vue?vue&type=script&lang=ts"

import "./coursedetail.vue?vue&type=style&index=0&id=d42e94e0&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42e94e0"]])

export default __exports__